const HEADING = 'Electricity plans aren’t available at this address.';
const BODY = 'This could be because you have solar or we don’t supply in your suburb';

export const ERGON_AVAILABILITY_ELEC: { heading: string; body: string } = {
  heading: HEADING,
  body: `${BODY}. If you’re an existing electricity customer and want to switch plans, [contact us](https://www.originenergy.com.au/contact/).`,
};

export const ERGON_AVAILABILITY_DUAL: { heading: string; body: string } = {
  heading: HEADING,
  body: `${BODY}. You can sign up to natural gas online. If you’re an existing electricity customer and want to switch plans, [contact us](https://www.originenergy.com.au/contact/).`,
};
